module.exports = __webpack_public_path__ + "img/28.4d239584.png";